import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../../../modules/react/hooks/useQuery';
import { compose, pure } from '../../../../src/web/utils/react';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';
import { facilityWidget, editor } from '../../../../src/web/components/widgets/decorators';
import FacilityAmenities from './FacilityAmenities';
import Editor from './Editor';

const GET_FACILITY = gql`
  query GetFacility($id: ID!) {
    facility(id: $id) {
      id
      ...FacilityAmenities
    }
  }

  ${FacilityAmenities.fragments.facility}
`;

const FacilityAmenitiesContainer = ({ facilityId, ...rest }) => {
  const { data, loading, error } = useQuery(GET_FACILITY, {
    variables: { id: facilityId },
  });

  if (loading || error) {
    return null;
  }

  const facility = data?.facility || {};

  return (
    <FacilityAmenities
      {...rest}
      facility={facility}
    />
  );
};

const component = compose(
  facilityWidget(
    { name: NAME, category: 'Facility', componentId: ID },
    { defaults: { overrides: {} } },
  ),
  editor(Editor),
  pure(),
)(FacilityAmenitiesContainer);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
